import { groupBy } from '../../utils/collection';

// сортирует элементы в данном своействе объекта
export const sortObjProperty = (obj, property) => {
  const objVar = obj;
  const tempArr = objVar[property];
  const separatedArr = groupBy(
    tempArr,
    (item) => (/^[a-z]/i.test(item) ? 'startsWithoutSymbol' : 'startsWithSymbol'),
    { startsWithoutSymbol: [], startsWithSymbol: [] }
  );

  separatedArr.startsWithoutSymbol.sort();
  separatedArr.startsWithSymbol.sort();
  objVar[property] = separatedArr.startsWithoutSymbol.concat(separatedArr.startsWithSymbol);

  return objVar;
};

// делает сортировку по любому колличеству свойств объектов, значения которых нужно сортировать
export const sortByFields = (arr, mainItemProperty, ...rest) => {
  const sortedMainProperty = arr.sort((a, b) => {
    if (a[mainItemProperty] > b[mainItemProperty]) {
      return 1;
    }
    if (a[mainItemProperty] < b[mainItemProperty]) {
      return -1;
    }
    return 0;
  });

  rest.forEach((prop) => sortedMainProperty.map((obj = {}) => sortObjProperty(obj, prop)));

  return sortedMainProperty;
};
